var _path;
const _excluded = ["title", "titleId"],
  _excluded2 = ["title", "titleId"],
  _excluded3 = ["className", "color", "size", "pointer"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef, memo } from "react";
import { hooks } from '@approvalmax/utils';
const SVG = /*#__PURE__*/React.forwardRef((_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M17 4.5a.5.5 0 0 0-1 0v10.793l-2.146-2.147a.5.5 0 0 0-.708.708l3 3a.5.5 0 0 0 .708 0l3-3a.5.5 0 0 0-.708-.708L17 15.293zm-14 15a.5.5 0 0 1 .5-.5h17a.5.5 0 0 1 0 1h-17a.5.5 0 0 1-.5-.5M7.5 4a.5.5 0 0 1 .5.5v10.793l2.146-2.147a.5.5 0 0 1 .708.708l-3 3a.5.5 0 0 1-.708 0l-3-3a.5.5 0 0 1 .708-.708L7 15.293V4.5a.5.5 0 0 1 .5-.5",
    clipRule: "evenodd"
  })));
});
const SvgFetch = (_ref2, ref) => {
  let {
      title,
      titleId
    } = _ref2,
    props = _objectWithoutProperties(_ref2, _excluded2);
  const {
      className = '',
      color,
      size,
      pointer
    } = props,
    restProps = _objectWithoutProperties(props, _excluded3);
  const isClient = hooks.useOnlyClientRendering();
  const colorClassNameMod = color ? 'am-icon_color-' + color : '';
  const sizeClassNameMod = size ? 'am-icon_size-' + size : '';
  const poinerClassNameMod = pointer ? 'am-icon_pointer' : '';
  const classNames = [className, 'am-icon', colorClassNameMod, sizeClassNameMod, poinerClassNameMod].join(' ');
  if (!isClient) return null;
  return /*#__PURE__*/React.createElement(SVG, _extends({
    className: classNames
  }, restProps));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgFetch);
const Memo = /*#__PURE__*/memo(ForwardRef);
export { Memo as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik0xNyA0LjVDMTcgNC4yMjM4NiAxNi43NzYxIDQgMTYuNSA0QzE2LjIyMzkgNCAxNiA0LjIyMzg2IDE2IDQuNVYxNS4yOTI5TDEzLjg1MzYgMTMuMTQ2NEMxMy42NTgzIDEyLjk1MTIgMTMuMzQxNyAxMi45NTEyIDEzLjE0NjQgMTMuMTQ2NEMxMi45NTEyIDEzLjM0MTcgMTIuOTUxMiAxMy42NTgzIDEzLjE0NjQgMTMuODUzNkwxNi4xNDY0IDE2Ljg1MzZDMTYuMzQxNyAxNy4wNDg4IDE2LjY1ODMgMTcuMDQ4OCAxNi44NTM2IDE2Ljg1MzZMMTkuODUzNiAxMy44NTM2QzIwLjA0ODggMTMuNjU4MyAyMC4wNDg4IDEzLjM0MTcgMTkuODUzNiAxMy4xNDY0QzE5LjY1ODMgMTIuOTUxMiAxOS4zNDE3IDEyLjk1MTIgMTkuMTQ2NCAxMy4xNDY0TDE3IDE1LjI5MjlWNC41Wk0zIDE5LjVDMyAxOS4yMjM5IDMuMjIzODYgMTkgMy41IDE5SDIwLjVDMjAuNzc2MSAxOSAyMSAxOS4yMjM5IDIxIDE5LjVDMjEgMTkuNzc2MSAyMC43NzYxIDIwIDIwLjUgMjBIMy41QzMuMjIzODYgMjAgMyAxOS43NzYxIDMgMTkuNVpNNy41IDRDNy43NzYxNCA0IDggNC4yMjM4NiA4IDQuNVYxNS4yOTI5TDEwLjE0NjQgMTMuMTQ2NEMxMC4zNDE3IDEyLjk1MTIgMTAuNjU4MyAxMi45NTEyIDEwLjg1MzYgMTMuMTQ2NEMxMS4wNDg4IDEzLjM0MTcgMTEuMDQ4OCAxMy42NTgzIDEwLjg1MzYgMTMuODUzNkw3Ljg1MzU1IDE2Ljg1MzZDNy42NTgyOSAxNy4wNDg4IDcuMzQxNzEgMTcuMDQ4OCA3LjE0NjQ1IDE2Ljg1MzZMNC4xNDY0NSAxMy44NTM2QzMuOTUxMTggMTMuNjU4MyAzLjk1MTE4IDEzLjM0MTcgNC4xNDY0NSAxMy4xNDY0QzQuMzQxNzEgMTIuOTUxMiA0LjY1ODI5IDEyLjk1MTIgNC44NTM1NSAxMy4xNDY0TDcgMTUuMjkyOVY0LjVDNyA0LjIyMzg2IDcuMjIzODYgNCA3LjUgNFoiIGZpbGw9ImN1cnJlbnRDb2xvciIvPgo8L3N2Zz4K";